<!-- PaymentReceiptPreference.vue -->
<script setup lang="ts">
import EmailInput from '../../../components/Inputs/EmailInput.vue';
import PhoneInput from '../../../components/Inputs/PhoneInput.vue';
import ListSelect from '../../../components/Select/ListSelect.vue';
import SimpleFlexTable from '../../../components/Table/SimpleFlexTable.vue';
import SimpleFlexTableTitledRow from '../../../components/Table/SimpleFlexTableTitledRow.vue';
import { initPinia } from '../../../lib/PiniaMgr';
import { useListStore } from '../../../lib/Stores/ListStore';
import { PaymentReceiptPreference_ReceiptCommunication } from '../../../Enums/ChoiceEnums'
import { IListItem } from '../../../lib/Api/List';
import { IPatientDecodeValue } from '../../../lib/Models/Patient/IPatientDecodeValue';

    const props = defineProps<{
        patientData: IPatientDecodeValue
    }>();

    // Initialize list store data
    const listStore = useListStore(initPinia());    
    listStore.getPaymentReceiptPreference_ReceiptCommunication();

    const emits = defineEmits(["update:patientData"]);
    function emitPatientData()
    {
        emits("update:patientData", props.patientData);
    }

    function changePreferenceType()
    {
        if (PaymentReceiptPreference_ReceiptCommunication.EmailOverride != props.patientData.prpType)
            props.patientData.prpOverrideEmail = undefined;
        if (PaymentReceiptPreference_ReceiptCommunication.TextOverride != props.patientData.prpType)
            props.patientData.prpOverridePhone = undefined;

        emitPatientData(); 
    }
</script>

<template>

    <template v-if="patientData">
        <SimpleFlexTable :columnClasses='["simple-cell TitleCol", "simple-cell"]'>
            <SimpleFlexTableTitledRow>
                <template #Title>Preference</template>
                <ListSelect 
                    v-model="patientData.prpType"
                    @update:modelValue="changePreferenceType"
                    :options="listStore.paymentReceiptPreference_ReceiptCommunication" />
            </SimpleFlexTableTitledRow>

            <SimpleFlexTableTitledRow v-if="(patientData.prpType ?? 0) == PaymentReceiptPreference_ReceiptCommunication.TextOverride" >
                <template #Title>Override Phone</template>
                <PhoneInput 
                    v-model="patientData.prpOverridePhone" 
                    @update:modelValue="emitPatientData" />
            </SimpleFlexTableTitledRow>            

            <SimpleFlexTableTitledRow v-if="(patientData.prpType ?? 0) == PaymentReceiptPreference_ReceiptCommunication.EmailOverride" >
                <template #Title>Override Email</template>
                <EmailInput 
                    v-model="patientData.prpOverrideEmail" 
                    @update:modelValue="emitPatientData"
                    :maxLength="50" />
            </SimpleFlexTableTitledRow>            
        </SimpleFlexTable>
    </template>
</template>